import React from 'react'

const Notifications = () => {
  return (
    <div>
      <h2>Notifications</h2>
    </div>
  )
}

export default Notifications
